// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"47dbe2d7","3474":"47dbe2d7","5121":"47dbe2d7","5877":"47dbe2d7","9736":"47dbe2d7"}[chunkId] + ".chunk.css";
};